import moment from "moment";

export class DateUtil {
  static format(date, format = "DD/MM/YYYY") {
    if (!date) {
      return "Invalid date";
    }
    const m = moment(date);
    if (!m.isValid()) {
      return "Invalid date";
    }
    return m.format(format);
  }

  static now(format = "YYYY-MM-DD") {
    return moment().format(format);
  }

  static addYears(date, years) {
    if (!date) {
      return "Invalid date";
    }
    const m = moment(date);
    if (!m.isValid()) {
      return "Invalid date";
    }
    return m.add(years, 'years').format("YYYY-MM-DD");
  }

  static getStartOfYear(date = moment(), format = "YYYY-MM-DD") {
    if (!date) {
      return "Invalid date";
    }
    const m = moment(date);
    if (!m.isValid()) {
      return "Invalid date";
    }
    return m.startOf('year').format(format);
  }
}
